export default __webpack_public_path__ + "static/media/error-red-circle.e92cc65e.svg";